export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10778.817c434a.jpg";